import gql from 'graphql-tag';

const SIMULATION_QUESTION_MUTATION = gql`
  mutation (
    $simulationId: ID!,
    $professionId: Int!,
    $questions: [CalculationRequestQuestionInput]!
  ) {  
    createSimulationAnswers(
      simulationId: $simulationId, 
      professionId: $professionId,
      questions: $questions
    ){
      simulationId
      state
      professionId
      questions{
        questionId
        questionLabel
        questionName
      }
    }
  }
`;

export default SIMULATION_QUESTION_MUTATION;
